<template>
<div id="covid_recirc_posts">
    <div>
        <h2>Latest Coronavirus Coverage</h2>
        <div class="recirc-posts-grid-container" >
            <div class="recirc-posts-section large-top-image">
                <template v-for="(post, index) in first_two_posts" >
                    <div :key="post.id" class="recirc-post">
                        <a :href="post.content_url">
                            <div class="post-image" :style="'background-image:url('+post.img_url+')'" ></div>
                        </a>
                        <div class="post-text">
                            <h3>
                                <a :href="post.content_url" v-html="display_title(post.heading1)" ></a>
                            </h3>
                            <div class="post-body-text" v-html="display_body_text(post.body)" ></div>
                            <div class="post-date" v-html="format_date(post.date)"></div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="recirc-posts-section stacked-posts">
                <template v-for="(post, index) in last_two_posts" >
                    <div :key="post.id" class="recirc-post">
                        <div class="post-text">
                            <h3>
                                <a :href="post.content_url" v-html="display_title(post.heading1)" ></a>
                            </h3>
                            <div class="post-body-text" v-html="display_body_text(post.body)" ></div>
                            <div class="post-date" v-html="format_date(post.date)"></div>
                        </div>
                        <a :href="post.content_url">
                            <div class="post-image" :style="'background-image:url('+post.img_url+')'" ></div>
                        </a>
                    </div>
                </template>
            </div>
        </div>

        <!--Second Row-->
        <div class="recirc-posts-grid-container second-row">
        
            <div class="recirc-posts-section stacked-posts ad-section">
                <div class="RC-AD RC-AD-BOX-MIDDLE DESKTOP-AD" style="float:left;"></div>
                <div class="inline-rc-ad-middle">
                    <div class="RC-AD RC-AD-BOX-MIDDLE"></div>
                    <br />
                    <br />
                </div>
            </div> 
        
            <div class="recirc-posts-section large-top-image">
                <template v-for="(post, index) in second_row_posts" >
                    <div :key="post.id" class="recirc-post">
                        <a :href="post.content_url">
                            <div class="post-image" :style="'background-image:url('+post.img_url+')'" ></div>
                        </a>
                        <div class="post-text">
                            <h3>
                                <a :href="post.content_url" v-html="display_title(post.heading1)" ></a>
                            </h3>
                            <div class="post-body-text" v-html="display_body_text(post.body)" ></div>
                            <div class="post-date" v-html="format_date(post.date)"></div>
                        </div>
                    </div>
                </template>
            </div>
            
        </div>
        
    </div>
</div>
</template>

<script>
export default {
    name: 'covid-recirc',
    data: function(){
        return {
            posts: [],
        };
    },
    created: function(){
        this.load_json();
    },

    computed: {

        posts_to_use: function(){
            return this.posts.filter(function(post){
                if(typeof post.img_url !== 'undefined' && post.img_url !== null && post.img_url.length > 0){
                    return post;
                }
            })
        },

        first_two_posts: function(){
            return this.posts_to_use.filter(function(post, index){
                if(index < 2){
                    return post;
                }
            });
        },

        last_two_posts: function(){
            return this.posts_to_use.filter(function(post, index){
                if(index > 1 && index < 4){
                    return post;
                }
            });
        },

        second_row_posts: function(){
            return this.posts_to_use.filter(function(post, index){
                if(index > 3 && index < 6){
                    return post;
                }
            });
        }
    },

    methods: {

        load_json: function(){

            axios.get('/coronavirus/recirc_feed.json')
            .then(function(res) {
                this.posts = res.data;
            }.bind(this));

        },

        display_title: function(title){
            return title.replace(/\\/g, "");
        },

        display_body_text: function(body){

            body = body.replace(/\\/g, "");
            var length = 70;
            if(body.length <= length){
                return body;
            }

            return body.substr(0, length)+'...';
        },

        format_date: function(post_date){

            const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];

            const d = new Date(post_date);
            // console.log(d, 'Date format');

            return  monthNames[d.getMonth()] + ' ' + d.getDate().toString();
            //document.write("The current month is " + monthNames[d.getMonth()]);
        },
    },
}
</script>